import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject, input, output } from '@angular/core';
import { merge } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFloppyDisk } from '@fortawesome/pro-solid-svg-icons';
import { ConstitutionFormStore } from './stores/constitution-form.store';
import { ConstitutionCapitalStore } from './stores/constitution-capital.store';
import { ConstitutionShareholdersStore } from './stores/constitution-shareholders.store';
import { ConstitutionAdministrationStore } from './stores/constitution-administration.store';
import { ConstitutionAttorniesStore } from './stores/constitution-attornies.store';
import { ConstitutionDeedObjectSectionComponent } from './sections/constitution-deed-object-section/constitution-deed-object-section.component';
import { ConstitutionCapitalSeriesSectionComponent } from './sections/constitution-capital-series-section/constitution-capital-series-section.component';
import { ConstitutionSociosSectionComponent } from './sections/constitution-socios-section/constitution-socios-section.component';
import { ConstitutionAdministrationSectionComponent } from './sections/constitution-administration-section/constitution-administration-section.component';
import { ConstitutionRepresentativesComponent } from "./sections/constitution-representatives/constitution-representatives.component";

@Component({
  selector: 'app-constitution-form',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FontAwesomeModule,
    ConstitutionDeedObjectSectionComponent,
    ConstitutionCapitalSeriesSectionComponent,
    ConstitutionSociosSectionComponent,
    ConstitutionAdministrationSectionComponent,
    ConstitutionRepresentativesComponent
],
  providers: [
    ConstitutionFormStore,
    ConstitutionCapitalStore,
    ConstitutionShareholdersStore,
    ConstitutionAdministrationStore,
    ConstitutionAttorniesStore
  ],
  templateUrl: './constitution-form.component.html',
  styleUrl: './constitution-form.component.scss'
})
export class ConstitutionFormComponent implements OnInit {

  readonly store = inject(ConstitutionFormStore);
  readonly clientId = input<number>(0);
  readonly activeTab = input<string>('');
  readonly formIsDirty = output<boolean>();

  readonly faFloppyDisk = faFloppyDisk;
  private readonly destroyRef = inject(DestroyRef);

  async ngOnInit(): Promise<void> {
    await this.store.init(this.clientId());

    merge(
      this.store.form.valueChanges,
      this.store.capitalStore.capitalSocialForm.valueChanges,
      this.store.shareholdersStore.socioForm.valueChanges,
      this.store.administrationStore.administrationForm.valueChanges,
      this.store.administrationStore.memberModalForm.valueChanges
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.formIsDirty.emit(true));
  }

  save(): Promise<boolean> {
    return this.store.saveAll(this.clientId());
  }
}